import React, { useRef, useState } from "react"
import { ChevronDown, Bus } from "lucide-react"
import { useClickOutside } from "../../hooks"
import { motion, AnimatePresence } from "framer-motion"

const transferOptions = [
  "Без трансфера",
  "С трансфером из аэропорта",
  "С трансфером в аэропорт",
  "С трансфером туда и обратно",
]

const DetailsTop = ({ t }) => {
  const [transferOption, setTransferOption] = useState("Без трансфера")
  const [isOpen, setIsOpen] = useState(false)

  // REFS
  const selectorRef = useRef(null)

  useClickOutside(selectorRef, () => setIsOpen(false))

  return (
    <div className="px-2 w-[80%]">
      {/* <div className="mt-3">
        <h2 className="text-sm text-info-main font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-info-main rounded-full"></span>
          {t("admin.flug_details")}
        </h2>
      </div> */}
      {/* 
      <div className="mb-6 relative">
        <button
          onClick={(e) => {
            e.stopPropagation()
            setIsOpen(!isOpen)
          }}
          className="w-full flex items-center gap-3 px-1 py-2 text-left text-dark-gray bg-light-gray/20 hover:bg-light-gray/40 rounded-md transition-colors text-[13px]"
        >
          <Bus className="w-4 h-4 text-light-gray shrink-0" />
          <span className="flex-1 truncate min-w-0">{transferOption}</span>
          <ChevronDown
            className={`w-4 h-4 shrink-0 text-light-gray transition-transform ${isOpen ? "rotate-180" : ""}`}
          />
        </button>
        <AnimatePresence>
          {isOpen && (
            <motion.div
              ref={selectorRef}
              className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-md z-10 h-28 overflow-y-auto"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              {transferOptions.map((option) => (
                <button
                  key={option}
                  onClick={(e) => {
                    e.stopPropagation()
                    setTransferOption(option)
                    setIsOpen(false)
                  }}
                  className="w-full text-[13px] px-2 py-1 text-left hover:bg-blue-50 transition-colors first:rounded-t-lg last:rounded-b-lg"
                >
                  {option}
                </button>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div> */}
    </div>
  )
}

export default DetailsTop
